import { Footer } from '@doordash/component-layout'
import { FeatureFlag } from '@doordash/lib-feature-flags'
import * as React from 'react'
import { NotifierWrapper, TYPES as NotifierTypes } from '../../atoms/notifier'
import ChangeLanguage from '../../molecules/change-language'
import Header from '../../molecules/header'

import { SimpleStyleType } from './constants'
import { footerStringProps } from './strings'
import { FooterWrapper, ChildrenWrapper } from './styles'

interface IHeaderButton {
  href: string
  title: string
}

type SimpleProps = {
  includeHeader?: boolean
  includeMobileHeader?: boolean
  headerButton?: IHeaderButton
  headerIsDark?: boolean
  includeFooter?: boolean
  children: React.ReactNode
  errorMessage?: string
  clearErrors?: () => void
  isMobile?: boolean
  type?: SimpleStyleType
}

// Takes in children which we expect to be a page component
// renders any common chrome across the pages as well
export const Simple: React.SFC<SimpleProps> = ({
  children,
  includeHeader,
  includeMobileHeader,
  headerButton,
  headerIsDark,
  includeFooter,
  errorMessage,
  clearErrors,
  isMobile,
  type = SimpleStyleType.Standard,
}) => (
  <React.Fragment>
    {includeHeader && (
      <Header
        isDark={headerIsDark}
        headerButton={headerButton}
        hideWhenMobile={!includeMobileHeader}
        isMobile={isMobile}
        type={type}
      />
    )}
    {errorMessage && (
      <NotifierWrapper
        message={errorMessage}
        onClose={clearErrors}
        type={NotifierTypes.INFO}
      />
    )}
    <ChildrenWrapper>{children}</ChildrenWrapper>
    {includeFooter && (
      <FeatureFlag
        on={() => (
          <FooterWrapper>
            <Footer
              isDasherApp={true}
              strings={footerStringProps()}
              renderChangeLanguage={() => <ChangeLanguage />}
            />
          </FooterWrapper>
        )}
        off={() => <Footer isDasherApp={true} strings={footerStringProps()} />}
        flagName="enable_i18n_language_selection"
      />
    )}
  </React.Fragment>
)

Simple.defaultProps = {
  includeHeader: true,
  headerIsDark: true,
  includeFooter: true,
  includeMobileHeader: true,
}

export default Simple
